import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
export default /*#__PURE__*/ React.forwardRef(function CheckboxTable(_param, ref) {
    var onClick = _param.onClick, rest = _object_without_properties(_param, [
        "onClick"
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "form-check form-check-st-3 ",
            style: {
                backgroundColor: ""
            },
            children: [
                /*#__PURE__*/ _jsx("input", _object_spread({
                    type: "checkbox",
                    className: "form-check-input",
                    style: {
                        height: "18px",
                        width: "18px"
                    },
                    ref: ref,
                    onClick: onClick
                }, rest)),
                /*#__PURE__*/ _jsx("label", {
                    className: "form-check-label",
                    id: "booty-check"
                })
            ]
        })
    });
});
